import { useCallback } from "react";
import { App, Result } from "antd";
import { providedModal } from "../others";
import { __ } from "../utils";
function useRealCommerceErrorHandling() {
  const {
    message: antdMessage,
    modal
  } = App.useApp();

  // TODO: use generic support URL from shortcode parameter
  return useCallback(function (_ref) {
    let {
      isBackendDown,
      errors,
      message,
      status
    } = _ref;
    let {
      alwaysModal,
      subTitle,
      closable
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      alwaysModal: false
    };
    if (isBackendDown || status === 500) {
      providedModal("error", /*#__PURE__*/React.createElement(Result, {
        title: message,
        subTitle: subTitle,
        status: "500",
        style: {
          paddingBottom: 15
        }
      }), modal, {
        onOk: () => window.location.href = __("https://devowl.io/support/"),
        okText: __("Contact support"),
        closable
      });
    } else if (alwaysModal) {
      providedModal("error", /*#__PURE__*/React.createElement(Result, {
        title: message,
        subTitle: subTitle,
        status: "403",
        style: {
          paddingBottom: 15
        }
      }), modal, {
        closable
      });
    } else {
      Array.from(errors).forEach(_ref2 => {
        let {
          message: msg
        } = _ref2;
        antdMessage.error(msg, 6);
      });
    }
  }, []);
}
export { useRealCommerceErrorHandling };